import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { BaseComponentConfig, ViewContainersService, UpdateComponentStoreService, ComponentConfig } from '@urbannex/view-containers';
import { featureGroupOptions } from './configoptions';

@Component({
  selector: 'ubs-feature-groups',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./feature-groups.component.scss']
})
export class FeatureGroupsComponent extends BaseComponentConfig implements OnInit {
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(featureGroupOptions);
   }
   ngOnInit(): void {}
}
